module.exports = __webpack_public_path__ + "img/default_avatar.eea976fa.png";